import React, { FC, PropsWithChildren, useContext } from 'react';
import { IStoreService, useStore } from './store';

const StoreContext = React.createContext<IStoreService>({} as IStoreService);
StoreContext.displayName = 'Store';

export const StoreProvider: FC<PropsWithChildren<{}>> = (props): JSX.Element => {
  return <StoreContext.Provider value={useStore()}>{props.children}</StoreContext.Provider>;
};

export const useStoreService = (): IStoreService => useContext(StoreContext);
